import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e2312c2c")

_pushScopeId("data-v-e2312c2c")
const _hoisted_1 = { class: "br-lg no-of mt-8 mb-32" }
const _hoisted_2 = {
  class: "df-middle bg-background px-16",
  style: {"height":"48px"}
}
const _hoisted_3 = { class: "flex-1" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Positions")
const _hoisted_5 = { class: "bg-white px-16" }
const _hoisted_6 = { class: "flex-1" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Copy")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("More")
const _hoisted_9 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_SymbolLink = _resolveComponent("SymbolLink")
  const _component_Icon = _resolveComponent("Icon")
  const _component_LoadingOr = _resolveComponent("LoadingOr")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_t, { path: "cup_19" }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createTextVNode(" (" + _toDisplayString(_ctx.master.orderNumbers) + ") ", 1)
      ]),
      _createVNode(_component_Pic, {
        src: `cup/wt/alarm${_ctx.isFollow ? '_off': ''}`,
        width: "16",
        height: "16"
      }, null, 8, ["src"]),
      _createVNode(_component_t, {
        path: "",
        class: ["f-sm ml-4 flw-btn", {'c-title': _ctx.isFollow}],
        onClick: _ctx.toggleFollow
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.isFollow ? _ctx.translate('cup_21') : _ctx.translate('cup_20')), 1)
        ]),
        _: 1
      }, 8, ["class", "onClick"])
    ]),
    _createVNode("div", _hoisted_5, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (item, index) => {
        return (_openBlock(), _createBlock("div", {
          key: index,
          class: ["pb-24 d-f", {'pt-24': index===0}]
        }, [
          _createVNode(_component_Pic, {
            src: item.icon,
            width: "32",
            height: "32",
            class: "mr-8",
            style: {"border-radius":"50%"}
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_6, [
            _createVNode("p", null, _toDisplayString(item.contactCode), 1),
            _createVNode("p", {
              class: item.buyType===2?'c-success':'c-danger'
            }, _toDisplayString(['','Sell','Buy'][item.buyType]) + "@" + _toDisplayString(item.createPrice), 3)
          ]),
          _createVNode(_component_SymbolLink, {
            code: item.contactCode,
            withHistoryBack: ""
          }, {
            default: _withId(() => [
              _createVNode(_component_t, {
                as: "div",
                path: "cup_22",
                class: "copy-btn br-lg"
              }, {
                default: _withId(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1032, ["code"])
        ], 2))
      }), 128)),
      (_ctx.haveMore)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "f-xs c-tip pt-8 pb-16 t-center",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
          }, [
            _createVNode(_component_LoadingOr, { loading: _ctx.loading }, {
              default: _withId(() => [
                _createVNode(_component_t, { path: "cup_35" }, {
                  default: _withId(() => [
                    _hoisted_8
                  ]),
                  _: 1
                }),
                _hoisted_9,
                _createVNode(_component_Icon, {
                  name: "caret-down",
                  sm: ""
                })
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})